import _ from 'lodash'
import getTitle from "./getTitle";

export default function getAliasName(item = {}, objPath = '', titlePath = '') {
  if (!_.isEmpty(titlePath) && !!_.get(item, titlePath)) return _.get(item, titlePath);

  const _name = _.has(item, objPath + '_name') ? _.get(item, objPath + '_name') : undefined;
  if (_name) return _name;

  const _obj = _.get(item, objPath);
  return (_obj && _obj.common_name) || getTitle(_obj);
}
